import axios from "axios";

export default function moveSn({ companyId, nodeId, fromSn, toSn, inputType }) {
  return new Promise((resolve, reject) =>
    axios
      .post("/serialnumber/system-admin/api/v1/management-sn/move", {
        company_id: companyId,
        node_id: nodeId,
        from_sn: fromSn,
        to_sn: toSn,
        input_type: inputType,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || error.message))
  );
}
